import { render, staticRenderFns } from "./ProfileRecurringItem.vue?vue&type=template&id=1dcfdf49&"
import script from "./ProfileRecurringItem.vue?vue&type=script&lang=ts&"
export * from "./ProfileRecurringItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports